import ArticleItemTop from '@/cmsComponents/ArticleItemTop';
import React from 'react';
import { IArticleSummary } from 'types/cms';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import styles from './ArticleListSection.module.scss';

interface IProps {
  articleListTitle?: string;
  articles: IArticleSummary[];
}

const ArticleListSection: React.FC<IProps> = ({ articles, articleListTitle }) => (
  <div className={styles.container}>
    {articleListTitle && (
      <div className={styles.titleContainer}>
        <Typography variant="h5" component="h2">
          {articleListTitle}
        </Typography>
      </div>
    )}
    <Grid container spacing={3}>
      {articles.map(article => (
        <Grid item key={article.id} sm={4} xs={12}>
          <ArticleItemTop article={article} />
        </Grid>
      ))}
    </Grid>
  </div>
);

export default ArticleListSection;
